import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import colors from "@constants/color";
import getWalletIcon from "./WalletIcon";

type AggHeaderProps = {
  summary: {
    value: string;
    value_txt: string;
    title: string;
    cta_txt: string;
    key: string;
  };
};

const AggHeaderCard: React.FC<AggHeaderProps> = ({ summary }) => {
  return (
    <View
      style={styles.headerContainer}
      testID={`${summary?.key}+${summary?.title}`}
    >
      {getWalletIcon(summary?.key)}
      <View
        style={styles.headerTextContainer}
        testID={`${summary?.key}+${summary?.title}+`}
      >
        <Text style={styles.headerAmount}>{summary?.value_txt}</Text>
        <Text variant="body_text_3" style={styles.headerLabel}>
          {summary?.title}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    backgroundColor: colors.white,
    borderRadius: 8,
    elevation: 1,
    marginHorizontal: 16,
  },
  headerTextContainer: {
    flex: 1,
    marginLeft: 12,
    flexDirection: "row",
    alignItems: "center",
  },
  headerAmount: {
    fontSize: 30,
    fontWeight: "bold",
    color: colors.mediumBlack,
    lineHeight: 40,
  },
  headerLabel: {
    color: colors.black06,
    marginLeft: 12,
    flex: 1,
    maxWidth: "55%",
  },
  withdrawButton: {
    position: "absolute",
    bottom: 16,
    right: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  withdrawText: {
    color: colors.darkGrey,
    marginRight: 4,
  },
  chevronIcon: {
    height: 12,
    width: 12,
  },
});

export default AggHeaderCard;
